import { render, staticRenderFns } from "./PrijavaCreate.vue?vue&type=template&id=4034f9f0&scoped=true&"
import script from "./PrijavaCreate.vue?vue&type=script&lang=js&"
export * from "./PrijavaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4034f9f0",
  null
  
)

export default component.exports